<script setup lang="tsx">
import {openAds,SlotContentGenerator} from "../api/ads.tsx"
import Headers from "./headers.vue";
import {activeTab} from "../config.ts";
import Footer from "./footer.vue";
import { useI18n } from 'vue-i18n';

// 获取 i18n 实例
const { t, locale } = useI18n();
import {createApp, h, onBeforeMount} from "vue";
let changeTab = (index: number) => {
  console.log(index)
  activeTab.value=index
}
// let views = [ChangeLog,Community,HomePage,Download,null]
import {tabs} from "../config.ts"
onBeforeMount(()=>{
    const params = new URLSearchParams(window.location.search);
    const tabValue = params.get('tab');
    if(tabValue){
      activeTab.value=parseInt(tabValue);
    }
})
const AdContent: SlotContentGenerator = () => (
    h('div', {
            className: 'card-content', // 在 h() 中，类名是 className 或 class
            innerHTML: t("rain_yun") // 或者使用 innerHTML，与 dangerouslySetInnerHTML 等效
        })
);


openAds(1,AdContent, { button:t("close"), });
</script>

<template>
  <Headers></Headers>
  <div v-for="(item,index) in tabs">
    <component v-if="index==activeTab" :is="item.view"></component>
  </div>
  <Footer :active-tab="activeTab" @change-tab="changeTab"></Footer>
</template>

<style scoped>

</style>
